import Vue from 'vue';

export default async (to, from, next) => {
    await Vue.loadScript("https://js.stripe.com/v3/");
    next();
};
